module.exports = __webpack_public_path__ + "img/guanchaxuexi.f4594845.png";